import Vue from 'vue'

export const SET_DATE_TO = (state, value) => {
  state.to = value
}

export const SET_DATE_FROM = (state, value) => {
  state.from = value
}

export const SET_SERIE = (state, value) => {
  state.serie = value
}

export const SET_NUMBER = (state, value) => {
  state.number = value
}

export const SET_DOCUMENTPROVIDER = (state, value) => {
  state.documentProvider = value
}

export const SET_DOCUMENTCLIENT = (state, value) => {
  state.documentClient = value
}

export const SET_AMOUNT = (state, value) => {
  state.amount = value
}

export const SET_STATUS = (state, value) => {
  state.status = value
}

export const SET_DELEGATION = (state, value) => {
  state.delegation = value
}

export const SET_ID = (state, value) => {
  state.id = value
}

export const SET_INVOICEID = (state, value) => {
  state.invoiceId = value
}

export const SET_TYPE = (state, value) => {
  state.type = value
}

export const SET_HISTORY = (state, { key, value }) => {
  let invoice = state.list.items.find(i => i.id === key)
  if (!invoice) return
  Vue.set(invoice, 'history', value)
}

export const SET_LOADED = (state, value) => {
  state.loaded = value
}

export const SET_NEWSTATUS = (state, value) => {
  state.newStatus = value
}

/* export const SET_SIIINVOICES = (state, { key, value }) => {
  let invoice = state.list.items.find(i => i.id === key)
  if (!invoice) return
  Vue.set(invoice, 'siiInvoices', value)
} */
